<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >

        <rkm-form
                ref="Form"
                show-legend
        >

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"

                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :options="form.anos"
                            :disabled="!!(model.periodo.start || model.periodo.end)"
                            @change="handleAnoChange"
                            default-option-text="Ano"
                            label="Ano"
                            show-default-option
                            text-field="descricao"
                            value-field="id"
                            v-model="model.ano"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.quadrimestres"
                            :disabled="!model.ano"
                            :validations="validations.quadrimestre"
                            @change="handleQuadrimestreChange"
                            default-option-text="Selecione"
                            label="Quadrimestre"
                            show-default-option
                            text-field="descricao"
                            value-field="id"
                            v-model="model.quadrimestre"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            value-field="id"
                            v-model="model.unidadeId"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.equipes"
                            default-option-text="Todas"
                            label="Equipe"
                            show-default-option
                            text-field="descricao"
                            v-model="model.equipeId"
                            value-field="id"
                        />
                    </rkm-col>

                      <rkm-col cols="4">
                          <rkm-form-select
                            :options="form.sexo"
                            default-option-text="Todos"
                            label="Sexo"
                            show-default-option
                            text-field="sexo"
                            v-model="model.sexoId"
                            value-field="id"
                          />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :options="form.boasPraticas"
                            :select-limit="null"
                            option-text-selecteds="boa prática selecionada"
                            label="Boas Práticas"
                            option-name-key="text"
                            v-model="model.boasPraticas"
                            value-field="value"
                        />
                    </rkm-col>

                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-group
                            label-for="faixa-etaria-inicial"
                            label="Faixa Etária Inicial"
                            class="mb-0"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Anos"
                                        :max="2"
                                        :min="0"
                                        type="number"
                                        v-model="model.faixaEtaria.inicial.anos"
                                    />
                                </rkm-col>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Meses"
                                        :max="11"
                                        :min="0"
                                        type="number"
                                        v-model="model.faixaEtaria.inicial.meses"
                                    />
                                </rkm-col>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Dias"
                                        :max="30"
                                        :min="0"
                                        type="number"
                                        v-model="model.faixaEtaria.inicial.dias"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-group
                            label-for="faixa-etaria-final"
                            label="Faixa Etária Final"
                            class="mb-0"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Anos"
                                        :max="2"
                                        :min="0"
                                        type="number"
                                        v-model="model.faixaEtaria.final.anos"
                                    />
                                </rkm-col>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Meses"
                                        :max="11"
                                        :min="0"
                                        type="number"
                                        v-model="model.faixaEtaria.final.meses"
                                    />
                                </rkm-col>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Dias"
                                        :max="30"
                                        :min="0"
                                        type="number"
                                        v-model="model.faixaEtaria.final.dias"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>

                    <rkm-col cols="1" class="mt-4">
                        <rkm-form-checkbox v-model="model.buscaAtiva">
                            Busca Ativa <rkm-icon v-rkm-tooltip.hover title="Exibe somente pacientes com pendência em uma ou mais boas práticas do indicador." :icon="['far', 'question-circle']" class="text-muted" />
                        </rkm-form-checkbox>
                    </rkm-col>

                    <rkm-col cols="1" class="mt-4">
                        <rkm-form-checkbox v-model="model.foraArea">
                            Fora de Área <rkm-icon v-rkm-tooltip.hover title="Quando marcado, inclui no cálculo e na busca ativa pacientes fora de área vinculados à equipe e elegíveis ao indicador." :icon="['far', 'question-circle']" class="text-muted" />
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :repository="repositories.paciente"
                            :searchFields="fields.autocomplete.paciente"
                            :minLength="3"
                            :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                            label="Paciente"
                            v-model="model.pacienteId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="8">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            @click="reset"
                            :label="false"

                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>

                </rkm-row>
        </rkm-form>
        </rkm-area>


        <template v-if="totalizadores">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-row v-if="totalizadores.semPublicoAlvo">
                    <rkm-col cols="12">
                        <rkm-alert color="warning">
                            Não há público-alvo para o período selecionado.
                        </rkm-alert>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>

         <template v-if="totalizadores">
                <rkm-area
                title="Totais"
                type="fieldset"
                no-margin-top
                >
            <rkm-row>
                <rkm-col cols="2">
                Pacientes
                <rkm-alert color="secondary">
                    <strong> {{ totalizadores.totalPacientes }} </strong>
                </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                Equipes
                <rkm-alert color="secondary">
                    <strong> {{ totalizadores.totalEquipes }} </strong>
                </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                Microareas
                <rkm-alert color="secondary">
                    <strong> {{ totalizadores.totalMicroareas }} </strong>
                </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                Denominador(D)
                <rkm-alert color="secondary">
                    <strong> {{ totalizadores.denominador }} </strong>
                </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                Numerador(N)
                <rkm-alert color="secondary">
                    <strong> {{ totalizadores.numerador }} </strong>
                </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                Resultado(%) <rkm-icon v-rkm-tooltip.hover title="Resultado calculado pela fórmula: (Numerador ÷ (Denominador × 100)) × 100." :icon="['far', 'question-circle']" class="text-muted" />
                <rkm-alert color="secondary">
                    <strong> {{ totalizadores.resultado }} </strong>
                </rkm-alert>
                </rkm-col>

            </rkm-row>

            <rkm-row>
                <rkm-col cols="2" v-for="pratica in searchedBoasPraticas" :key="pratica">
                % Boa Prática {{ pratica }} <rkm-icon v-rkm-tooltip.hover :title="tooltipBoasPraticas[pratica]" :icon="['far', 'question-circle']" class="text-muted" />
                <rkm-alert color="secondary">
                    <strong> {{ totalizadores.boasPraticas[pratica].percentual }}% </strong>
                </rkm-alert>
                </rkm-col>
            </rkm-row>
            </rkm-area>
        </template>

        <template v-if="resultadoPorEquipe && resultadoPorEquipe.length > 0">
            <rkm-area
                no-margin-top
                title="Resultado por Equipe"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="tableFieldsPorEquipe"
                            :items="resultadoPorEquipe"
                            @sort-changed="onSortChangedEquipe"
                        >
                            <template v-slot:head(resultado)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Resultado calculado pela fórmula: (Numerador ÷ (Denominador × 100)) × 100." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(classificacao)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Faixa de desempenho da equipe conforme parâmetro do indicador." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(percentualA)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="1ª consulta presencial com médica(o) ou enfermeira(o) até o 30º dia de vida." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(percentualB)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Pelo menos 9 consultas presenciais ou remotas com médica(o) ou enfermeira(o) até 2 anos de vida." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(percentualC)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Pelo menos 9 registros simultâneos de peso e altura até 2 anos de vida." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(percentualD)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Pelo menos 2 visitas domiciliares por ACS/TACS, sendo a primeira até 30 dias e a segunda até 6 meses." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(percentualE)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Vacinas monitoradas pelo indicador registradas com todas as doses recomendadas." :icon="['far', 'question-circle']" class="text-muted" /></template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>

        <template v-if="model.buscaAtiva && buscaAtivaDados && buscaAtivaDados.length > 0">
            <rkm-area
                no-margin-top
                title="Busca Ativa - Pacientes com Pendências"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminateBuscaAtiva"
                            @change="selectAllBuscaAtiva"
                            class="mx-2"
                            v-model="selectedAllBuscaAtiva"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="optionalColumnsBuscaAtiva"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="selectedColsBuscaAtiva"
                            value-field="key"
                        />
                    </rkm-dropdown>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="tableFieldsBuscaAtiva"
                            :items="buscaAtivaDados"
                            @sort-changed="onSortChangedBuscaAtiva"
                        >
                            <template v-slot:head(indicadorA)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="1ª consulta presencial com médica(o) ou enfermeira(o) até o 30º dia de vida." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(indicadorB)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Pelo menos 9 consultas presenciais ou remotas com médica(o) ou enfermeira(o) até 2 anos de vida." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(indicadorC)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Pelo menos 9 registros simultâneos de peso e altura até 2 anos de vida." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(indicadorD)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Pelo menos 2 visitas domiciliares por ACS/TACS, sendo a primeira até 30 dias e a segunda até 6 meses." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(indicadorE)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Vacinas monitoradas pelo indicador registradas com todas as doses recomendadas." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template v-slot:head(pendencias)="row">{{ row.label }} <rkm-icon v-rkm-tooltip.hover title="Mostra qual boa prática ainda não foi cumprida pelo paciente no período analisado." :icon="['far', 'question-circle']" class="text-muted" /></template>
                            <template #cell(indicadorA)="data">
                                <span v-if="data.item.indicadorA" class="badge badge-success">✓</span>
                                <span v-else class="badge badge-danger">X</span>
                            </template>
                            <template #cell(indicadorB)="data">
                                <span v-if="data.item.indicadorB" class="badge badge-success">✓</span>
                                <span v-else class="badge badge-danger">X</span>
                            </template>
                            <template #cell(indicadorC)="data">
                                <span v-if="data.item.indicadorC" class="badge badge-success">✓</span>
                                <span v-else class="badge badge-danger">X</span>
                            </template>
                            <template #cell(indicadorD)="data">
                                <span v-if="data.item.indicadorD" class="badge badge-success">✓</span>
                                <span v-else-if="data.item.areaTipoId === 5" class="badge badge-secondary">N/C</span>
                                <span v-else class="badge badge-danger">X</span>
                            </template>
                            <template #cell(indicadorE)="data">
                                <span v-if="data.item.indicadorE" class="badge badge-success">✓</span>
                                <span v-else class="badge badge-danger">X</span>
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>

    </div>
</template>

<script>

// Mixins.
import {error, file, repository, stringCase, formats} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Others.
import moment from 'moment'


export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                quadrimestre: this.model?.ano ? {required: true} : {},
            }
        },
        tableFieldsPorEquipe() {
            const base = [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true},
                {key: 'denominador', label: 'Denominador (D)', sortable: true},
                {key: 'numerador', label: 'Numerador (N)', sortable: true},
                {key: 'resultado', label: 'Resultado (%)', sortable: true},
                {key: 'classificacao', label: 'Classificação', sortable: true},
            ]
            const praticasDisponiveis = {
                'A': {key: 'percentualA', label: '% Prática A', sortable: true},
                'B': {key: 'percentualB', label: '% Prática B', sortable: true},
                'C': {key: 'percentualC', label: '% Prática C', sortable: true},
                'D': {key: 'percentualD', label: '% Prática D', sortable: true},
                'E': {key: 'percentualE', label: '% Prática E', sortable: true},
            }
            return [...base, ...this.searchedBoasPraticas.filter(p => praticasDisponiveis[p]).map(p => praticasDisponiveis[p])]
        },
        optionalColumnsBuscaAtiva() {
            return this.columnsBuscaAtiva.filter(c => !c.fixed)
        },
        tooltipBoasPraticas() {
            return {
                'A': '1ª consulta presencial com médica(o) ou enfermeira(o) até o 30º dia de vida.',
                'B': 'Pelo menos 9 consultas presenciais ou remotas com médica(o) ou enfermeira(o) até 2 anos de vida.',
                'C': 'Pelo menos 9 registros simultâneos de peso e altura até 2 anos de vida.',
                'D': 'Pelo menos 2 visitas domiciliares por ACS/TACS, sendo a primeira até 30 dias e a segunda até 6 meses.',
                'E': 'Vacinas monitoradas pelo indicador registradas com todas as doses recomendadas.',
            }
        },
        tableFieldsBuscaAtiva() {
            const colunasFiltradas = this.columnsBuscaAtiva
                .filter(c => c.fixed || this.selectedColsBuscaAtiva.includes(c.key))

            const indicadoresDisponiveis = {
                'A': {key: 'indicadorA', label: 'A', sortable: false},
                'B': {key: 'indicadorB', label: 'B', sortable: false},
                'C': {key: 'indicadorC', label: 'C', sortable: false},
                'D': {key: 'indicadorD', label: 'D', sortable: false},
                'E': {key: 'indicadorE', label: 'E', sortable: false},
            }
            const indicadores = this.searchedBoasPraticas
                .filter(p => indicadoresDisponiveis[p])
                .map(p => indicadoresDisponiveis[p])

            return [...colunasFiltradas, ...indicadores, {key: 'pontuacaoTotal', label: 'Pontuação Total', sortable: true}]
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            relatorioCuidadoDesenvolvimentoInfantil: this.getConectaSusRepository('atencaoBasica.relatorioCuidadoDesenvolvimentoInfantil'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }

        this.load()
    },
    data(){

        return {
            form: null,
            model: null,
            items: [],
            totalizadores: null,
            resultadoPorEquipe: null,
            buscaAtivaDados: null,
            searchedBoasPraticas: ['A', 'B', 'C', 'D', 'E'],
            sortByEquipe: 'unidadeNomeFantasia',
            sortDescEquipe: false,
            sortByBuscaAtiva: 'unidadeNomeFantasia',
            sortDescBuscaAtiva: false,
            selectedColsBuscaAtiva: ['pacienteDataNascimento'],
            selectedAllBuscaAtiva: false,
            indeterminateBuscaAtiva: true,
            columnsBuscaAtiva: [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true, fixed: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true, fixed: true},
                {key: 'pacienteNome', label: 'Paciente', sortable: true, fixed: true},
                {key: 'pacienteSexo', label: 'Sexo', sortable: true, fixed: true},
                {key: 'idadeCompleta', label: 'Idade', sortable: true, fixed: true},
                {key: 'usuarioResponsavelNome', label: 'Usuário Responsável', sortable: true, fixed: true},
                {key: 'pacienteDataNascimento', label: 'Data de Nascimento', sortable: true},
                {key: 'pacienteTelefone', label: 'Telefone', sortable: true, formatter: value => value ? this.formatPhoneOrCellPhone(value) : ''},
                {key: 'pacienteEndereco', label: 'Endereço', sortable: true},
                {key: 'areaMicroareaDomicilio', label: 'Area/Microarea do Domicilio', sortable: true},
            ],
            others: {moment},
            fields: {
                    autocomplete: {
                        paciente: [
                            { key: "cidadao.nome", searchable: true }
                        ],
                    },
                },
        }
    },


    methods: {
         ...mapActions(['setLoading', 'unsetLoading']),
        getPeriodoRequest(periodo = this.model.periodo) {
            return {
                start: this.others.moment(periodo.start).format('DD/MM/YYYY'),
                end: this.others.moment(periodo.end).format('DD/MM/YYYY'),
            }
        },
        exportTo(){
            this.setLoading()

            const request = {
                periodo: this.getPeriodoRequest(),
                quadrimestre: this.model.ano && this.model.quadrimestre ? `${this.model.ano}-${this.model.quadrimestre}` : null,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: this.model.equipeId,
                sexoId: this.model.sexoId,
                boasPraticas: this.model.boasPraticas,
                buscaAtiva: this.model.buscaAtiva,
                foraArea: this.model.foraArea,
                faixaEtaria: this.model.faixaEtaria,
            }

            if (this.model.pacienteId) {
                request.pacienteId = this.model.pacienteId
            }

            request.sortByEquipe = this.sortByEquipe
            request.sortDescEquipe = this.sortDescEquipe
            request.sortByBuscaAtiva = this.sortByBuscaAtiva
            request.sortDescBuscaAtiva = this.sortDescBuscaAtiva
            request.selectedColsBuscaAtiva = this.selectedColsBuscaAtiva

            this.repositories.exportacao.relatorioCuidadoDesenvolvimentoInfantil(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())

        },
        print() {
            this.setLoading()

            const request = {
                periodo: this.getPeriodoRequest(),
                quadrimestre: this.model.ano && this.model.quadrimestre ? `${this.model.ano}-${this.model.quadrimestre}` : null,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: this.model.equipeId,
                sexoId: this.model.sexoId,
                boasPraticas: this.model.boasPraticas,
                buscaAtiva: this.model.buscaAtiva,
                foraArea: this.model.foraArea,
                faixaEtaria: this.model.faixaEtaria,
            }

            if (this.model.pacienteId) {
                request.pacienteId = this.model.pacienteId
            }

            request.sortByEquipe = this.sortByEquipe
            request.sortDescEquipe = this.sortDescEquipe
            request.sortByBuscaAtiva = this.sortByBuscaAtiva
            request.sortDescBuscaAtiva = this.sortDescBuscaAtiva
            request.selectedColsBuscaAtiva = this.selectedColsBuscaAtiva

            this.repositories.impressao.relatorioCuidadoDesenvolvimentoInfantil(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())

        },
        syncAnoQuadrimestre(periodo) {
            if (!this.model) return

            if (!periodo?.start || !periodo?.end) {
                this.model.ano = null
                this.model.quadrimestre = null
                return
            }

            const startMoment = this.others.moment(periodo.start)
            const endMoment = this.others.moment(periodo.end)
            const startYear = startMoment.year()
            const endYear = endMoment.year()

            if (startYear !== endYear) {
                this.model.ano = null
                this.model.quadrimestre = null
                return
            }

            const startMD = startMoment.format('MM-DD')
            const endMD = endMoment.format('MM-DD')
            const faixas = [
                { id: 1, startMD: '01-01', endMD: '04-30' },
                { id: 2, startMD: '05-01', endMD: '08-31' },
                { id: 3, startMD: '09-01', endMD: '12-31' },
            ]
            const matched = faixas.find(f => f.startMD === startMD && f.endMD === endMD)

            this.model.ano = matched ? startYear : null
            this.model.quadrimestre = matched ? matched.id : null
        },
        applyAnoQuadrimestreAoPeriodo() {
            if (!this.model.ano || !this.model.quadrimestre) return

            const faixas = {
                1: { start: `${this.model.ano}-01-01`, end: `${this.model.ano}-04-30` },
                2: { start: `${this.model.ano}-05-01`, end: `${this.model.ano}-08-31` },
                3: { start: `${this.model.ano}-09-01`, end: `${this.model.ano}-12-31` },
            }
            const faixa = faixas[this.model.quadrimestre]
            if (!faixa) return

            this.model.periodo = {
                start: this.others.moment(faixa.start, 'YYYY-MM-DD').toDate(),
                end: this.others.moment(faixa.end, 'YYYY-MM-DD').toDate(),
            }
        },
        handleAnoChange() {
            this.applyAnoQuadrimestreAoPeriodo()
        },
        handleQuadrimestreChange() {
            this.applyAnoQuadrimestreAoPeriodo()
        },
        load(){
            this.setLoading()

            this.repositories.relatorioCuidadoDesenvolvimentoInfantil.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: this.getPeriodoRequest(),
                quadrimestre: this.model.ano && this.model.quadrimestre ? `${this.model.ano}-${this.model.quadrimestre}` : null,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: this.model.equipeId,
                sexoId: this.model.sexoId,
                boasPraticas: this.model.boasPraticas,
                buscaAtiva: this.model.buscaAtiva,
                foraArea: this.model.foraArea,
                faixaEtaria: this.model.faixaEtaria,
            }


            if (this.model.pacienteId) {
                request.pacienteId = this.model.pacienteId
            }

            this.setLoading()

            this.repositories.relatorioCuidadoDesenvolvimentoInfantil.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = response.data.data || []
                    this.totalizadores = response.data.totalizadores
                    this.resultadoPorEquipe = response.data.resultadoPorEquipe || []
                    this.buscaAtivaDados = response.data.buscaAtiva || []
                    this.searchedBoasPraticas = response.data.boasPraticasSelecionadas || ['A', 'B', 'C', 'D', 'E']
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.equipes = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.ano = null
            this.model.quadrimestre = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.equipeId = null
            this.model.sexoId = null
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E']
            this.model.pacienteId = null
            this.model.buscaAtiva = false
            this.model.foraArea = false
            this.model.faixaEtaria.inicial.anos = null
            this.model.faixaEtaria.inicial.meses = null
            this.model.faixaEtaria.inicial.dias = null
            this.model.faixaEtaria.final.anos = null
            this.model.faixaEtaria.final.meses = null
            this.model.faixaEtaria.final.dias = null

            this.items = []
            this.totalizadores = null
            this.resultadoPorEquipe = []
            this.buscaAtivaDados = []
            this.searchedBoasPraticas = ['A', 'B', 'C', 'D', 'E']

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        handleUnidadeChange(value) {
            this.model.faixaEtaria.inicial.anos = null
            this.model.faixaEtaria.inicial.meses = null
            this.model.faixaEtaria.inicial.dias = null
            this.model.faixaEtaria.final.anos = null
            this.model.faixaEtaria.final.meses = null
            this.model.faixaEtaria.final.dias = null

            this.form.infraestruturas = []
            this.form.equipes = []

            this.model.infraestruturaId = null
            this.model.equipeId = null
            this.model.sexoId = null
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E']
            this.model.pacienteId = null
            this.model.buscaAtiva = false
            this.model.foraArea = false

            this.items = []
            this.totalizadores = null
            this.resultadoPorEquipe = []
            this.buscaAtivaDados = []

            const request = {
                listar: 'infraestruturas',
                periodo: this.getPeriodoRequest(),
                quadrimestre: this.model.ano && this.model.quadrimestre ? `${this.model.ano}-${this.model.quadrimestre}` : null,
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoDesenvolvimentoInfantil.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.equipes = Object.assign(response.data.equipes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        onSortChangedEquipe(context) {
            this.sortByEquipe = context.sortBy
            this.sortDescEquipe = context.sortDesc
        },
        onSortChangedBuscaAtiva(context) {
            this.sortByBuscaAtiva = context.sortBy
            this.sortDescBuscaAtiva = context.sortDesc
        },
        selectAllBuscaAtiva(selected) {
            this.selectedColsBuscaAtiva = selected ? this.optionalColumnsBuscaAtiva.map(c => c.key) : []
        },
        handleInfraestruturaChange(value) {
            this.model.faixaEtaria.inicial.anos = null
            this.model.faixaEtaria.inicial.meses = null
            this.model.faixaEtaria.inicial.dias = null
            this.model.faixaEtaria.final.anos = null
            this.model.faixaEtaria.final.meses = null
            this.model.faixaEtaria.final.dias = null
            this.form.equipes = []
            this.model.equipeId = null
            this.model.sexoId = null
            this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E']
            this.model.pacienteId = null
            this.model.buscaAtiva = false
            this.model.foraArea = false

            this.items = []
            this.totalizadores = null
            this.resultadoPorEquipe = []
            this.buscaAtivaDados = []

            const request = {
                listar: 'equipes',
                periodo: this.getPeriodoRequest(),
                quadrimestre: this.model.ano && this.model.quadrimestre ? `${this.model.ano}-${this.model.quadrimestre}` : null,
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioCuidadoDesenvolvimentoInfantil.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.equipes = Object.assign(response.data.equipes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, repository, stringCase, formats],
        watch: {
        selectedColsBuscaAtiva(newValue) {
            const total = this.optionalColumnsBuscaAtiva.length
            this.selectedAllBuscaAtiva = newValue.length > 0 && newValue.length === total
            this.indeterminateBuscaAtiva = newValue.length > 0 && newValue.length !== total
        },
        'model.faixaEtaria': {
            deep: true,
            handler(faixa) {
                const clamp = (value, max) => {
                    if (value === null || value === undefined || value === '') return null
                    const parsed = parseInt(value, 10)
                    if (Number.isNaN(parsed)) return null
                    return Math.max(0, Math.min(parsed, max))
                }

                faixa.inicial.anos = clamp(faixa.inicial.anos, 2)
                faixa.inicial.meses = clamp(faixa.inicial.meses, 11)
                faixa.inicial.dias = clamp(faixa.inicial.dias, 30)

                faixa.final.anos = clamp(faixa.final.anos, 2)
                faixa.final.meses = clamp(faixa.final.meses, 11)
                faixa.final.dias = clamp(faixa.final.dias, 30)
            },
        },
        'model.periodo': {
            deep: true,
            handler(value) {
                this.syncAnoQuadrimestre(value)
                this.model.faixaEtaria.inicial.anos = null
                this.model.faixaEtaria.inicial.meses = null
                this.model.faixaEtaria.inicial.dias = null
                this.model.faixaEtaria.final.anos = null
                this.model.faixaEtaria.final.meses = null
                this.model.faixaEtaria.final.dias = null

                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.equipes = []

                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.equipeId = null
                this.model.sexoId = null
                this.model.boasPraticas = ['A', 'B', 'C', 'D', 'E']
                this.model.pacienteId = null
                this.model.buscaAtiva = false
                this.model.foraArea = false

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: this.getPeriodoRequest(value),
                    quadrimestre: this.model.ano && this.model.quadrimestre ? `${this.model.ano}-${this.model.quadrimestre}` : null,
                }

                this.setLoading()

                this.repositories.relatorioCuidadoDesenvolvimentoInfantil.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.equipes = Object.assign(response.data.equipes)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            },
        },
    },
}
</script>